<div class="sidenav-content">
	<div class="card-block-padding card-title-block">
		<copo-back-button></copo-back-button>
		<div class="card-title-label" translate>need4steel.offers.title</div>
		<button  type="button" mat-button color="primary" class="n4steel-contact-email-button" (click)="openContactMailDialog()">
			<mat-icon svgIcon="mail"></mat-icon>
			<span class="n4steel-contact-email-span" translate>arcelormittal.need4steel.entry</span>
		</button>
	</div>
	<copo-need-steel-content></copo-need-steel-content>
</div>